var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{class:{
    'f-weight-bold': _vm.bold,
    'f-size-xx-small': _vm.xxsmall,
    'f-size-x-small': _vm.xsmall,
    'f-size-small': _vm.small,
    'f-size-medium': _vm.medium,
    'f-size-large': _vm.large,
    'f-family-ja-contract': _vm.jaContract,
    'f-family-en-contract': _vm.enContract
  },style:({
    color: _vm.color
  }),on:{"click":function($event){return _vm.$emit('click', $event)}}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }